import React, { useEffect, useState } from "react";
import "../MainRegister/mainRegister.css";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import VerifyMobileEmail from "../VerifyMobile/VerifyMobileEmail";
import PhoneInput from "react-phone-input-2";

export default function MainRegister() {
  const [click, setClick] = useState();

  const [registerState, setRegisterState] = useState({
    username: JSON.parse(localStorage.getItem("UserName")),
    emailid: JSON.parse(localStorage.getItem("Email")),
    contactN: JSON.parse(localStorage.getItem("Mobile_no")),
  });

  const {
    formState: { errors },
  } = useForm();

  // get data from local storage
  const School_id = JSON.parse(localStorage.getItem("School_id"));
  const Email_id = JSON.parse(localStorage.getItem("Email"));
  const CNumber = JSON.parse(localStorage.getItem("Mobile_no"));

  const [registerStateValidate, setRegisterStateValidate] = useState({
    isusernameValid: null,
    usernameValidationMsg: "",

    isEmailidValid: null,
    emailIdValidationMsg: "",

    isContactValid: null,
    contactValidationMsg: "",
    // contactN: "",
  });

  const validateRegistration = () => {
    const usernameRE = /^[a-zA-Z]{3,20}\s[a-zA-Z]{1,20}(\s[a-zA-Z]{1,20})?$/;

    let isvalid = false;

    // for username validation
    if (!registerState.username) {
      setRegisterStateValidate({
        ...registerStateValidate,
        isusernameValid: false,
        usernameValidationMsg: "usernameReq",
      });
      isvalid = false;
    } else {
      /*else if (registerState.username && !usernameRE.test(registerState.username)) {
        setRegisterStateValidate({
          ...registerStateValidate,
          isusernameValid: false,
          usernameValidationMsg: 'usernamePattern'
        })
        isvalid = false
      }*/
      setRegisterStateValidate({
        ...registerStateValidate,
        isusernameValid: true,
        usernameValidationMsg: "",
      });
      isvalid = true;
    }
    return isvalid;
  };

  const validateRegistrationEmail = () => {
    const emailIdRe =
      /^(?=.{1,40}$)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/;

    let isvalid = false;

    if (!registerState.emailid) {
      setRegisterStateValidate({
        ...registerStateValidate,
        isEmailidValid: false,
        emailIdValidationMsg: "emailIdReq",
      });
      isvalid = false;
    } else if (
      registerState.emailid &&
      !emailIdRe.test(registerState.emailid)
    ) {
      setRegisterStateValidate({
        ...registerStateValidate,
        isEmailidValid: false,
        emailIdValidationMsg: "emailIdPattern",
      });
      isvalid = false;
    } else {
      setRegisterStateValidate({
        ...registerStateValidate,
        isEmailidValid: true,
        emailIdValidationMsg: "",
      });
      isvalid = true;
    }
    // end part

    return isvalid;
  };

  const validateRegistrationContactN = () => {
    const ContactNRe = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    let isvalid = false;
    if (!registerState.contactN) {
      setRegisterStateValidate({
        ...registerStateValidate,
        isContactValid: false,
        contactValidationMsg: "contactNReq",
      });
      isvalid = false;
    } else if (
      registerState.contactN &&
      !ContactNRe.test(registerState.contactN)
    ) {
      setRegisterStateValidate({
        ...registerStateValidate,
        isContactValid: false,
        contactValidationMsg: "contactNPattern",
      });
      isvalid = false;
    } else {
      setRegisterStateValidate({
        ...registerStateValidate,
        isContactValid: true,
        contactValidationMsg: "",
      });
      isvalid = true;
    }
    // end part

    return isvalid;
  };

  useEffect(() => {
    validateRegistration();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerState.username]);

  useEffect(() => {
    validateRegistrationEmail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerState.emailid]);
  useEffect(() => {
    validateRegistrationContactN();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerState.contactN]);

  const handleSubmit = (e) => {
    e.preventDefault();
    validateRegistration() && validateRegistrationEmail() && setClick(true);
  };

  // const [continuebtn, setContinuebtn] = useState(true)

  // useEffect(() => {
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   validateRegistration() && validateRegistrationEmail() && validateRegistrationContactN() ? setContinuebtn(false) : setContinuebtn(true)
  // }, [registerStateValidate])

  useEffect(() => {
    setRegisterStateValidate({
      ...registerStateValidate,
      isusernameValid: true,
      usernameValidationMsg: "",

      isEmailidValid: true,
      emailIdValidationMsg: "",

      isContactValid: true,
      contactValidationMsg: "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const formattedNumber = CNumber
    ? "+91 - " + CNumber.toString().replace(/(\d{4})(\d{4})(\d{2})/, "$1 $2 $3")
    : "--";
  // const formattedNumber = 9111517531
  //   const [countryCode, setCountryCode] = useState("+Unknown");
  //   const [countryName, setCountryName] = useState("Unknown");

  //   useEffect(() => {
  //     async function fetchCountryCodes() {
  //       const response = await fetch(
  //         "https://restcountries.com/v2/all?fields=name,callingCodes"
  //       );
  //       const data = await response.json();
  //       const countryCodes = {};

  //       data.forEach((country) => {
  //         if (country.callingCodes.length > 0) {
  //           countryCodes["+" + country.callingCodes[0]] = country.name;
  //         }
  //       });

  //       for (const code in countryCodes) {
  //         if (formattedNumber.toString().startsWith(code.slice(1))) {
  //           setCountryCode(code);
  //           setCountryName(countryCodes[code]);
  //           break;
  //         }
  //       }
  //     }

  //     fetchCountryCodes();
  //   }, [formattedNumber]);

  const MaskedEmail = (email) => {
    const maskEmail = (email) => {
      if (!email || typeof email !== "string") return email;

      const [localPart, domain] = email.split("@");
      if (!localPart || !domain) return email;

      // Mask local part
      const firstPart = localPart.slice(0, 2);
      const maskedLocalMiddle = "*".repeat(Math.max(localPart.length - 4, 5));
      // const lastPart = localPart.slice(-1);

      // Mask domain
      const [domainName, domainExtension] = domain.split(".");
      const maskedDomainMiddle = "*".repeat(Math.max(domainName.length - 2, 3));
      // const firstDomainPart = domainName.slice(0, 1);
      const lastDomainPart = domainName.slice(-1);

      const maskedDomain = `${maskedDomainMiddle}${lastDomainPart}.${domainExtension}`;

      return `${firstPart}${maskedLocalMiddle}@${maskedDomain}`;
    };

    return <spna>{maskEmail(email)}</spna>;
  };

  const maskPhoneNumber = (phone) => {
    if (!phone) return "";

    const phoneStr = phone.toString();

    // Show first 2 and last 2 digits
    return (
      phoneStr.slice(0, 2) +
      "*".repeat(phoneStr.length - 4) +
      phoneStr.slice(-2)
    );
  };

  return (
    <>
      {!click && (
        <div className="TotalContainer d-md-flex m-0 p-0 p-md-2 ">
          {/* <div className='MainContainer col-12 p-0  d-md-flex '> */}

          <div className="banner_box col-lg-3 col-md-5 col-12 p-0 m-0">
            <img
              className="banner_img "
              src="/Register-img/baner_img.jpg"
              alt="banner img"
            ></img>
          </div>

          <div className="form_box col-lg-9 col-md-7 col-12 p-0">
            <form>
              {/* <form onSubmit={(e) => NewHandleSubmit(e) }> */}
              <div>
                <div className="total_logo_regist">
                  <img
                    className="logo_registration"
                    src="/Register-img/Register_logo.png"
                    alt="register logo"
                  ></img>
                </div>
                <div className="title_regis">Get Started</div>

                <div className="combine_ip ">
                  {/* Name */}
                  <div>
                    <input
                      id="enterNameR"
                      required
                      placeholder="Enter full name"
                      className={
                        registerStateValidate.isusernameValid === false
                          ? `form-control ${errors.name && "invalid"}`
                          : ""
                      }
                      value={registerState.username}
                      onChange={(e) =>
                        setRegisterState({
                          ...registerState,
                          username: e.target.value,
                        })
                      }
                      autocomplete="off"
                    />
                  </div>

                  {registerStateValidate.isusernameValid === false &&
                    registerStateValidate.usernameValidationMsg ===
                      "usernameReq" && (
                      <small className="text-danger">
                        {"Username is Required"}
                      </small>
                    )}
                  {registerStateValidate.isusernameValid === false &&
                    registerStateValidate.usernameValidationMsg ===
                      "usernamePattern" && (
                      <small className="text-danger">
                        {"Enter Vaild Username"}
                      </small>
                    )}

                  {/*School ID*/}
                  <div id="enterNameR_school">
                    <div
                      className="input_register_local"
                      placeholder="Enter Your School ID"
                    >
                      {School_id}
                    </div>
                  </div>

                  {/*Email ID */}
                  {registerState.emailid ? (
                    <div id="enterNameR_school">
                      <div className="input_register_local">
                        {MaskedEmail(Email_id)}
                      </div>
                    </div>
                  ) : (
                    <div>
                      <input
                        id="enterNameR"
                        required
                        readOnly
                        placeholder="Email Id is not registered!!"
                        className={
                          registerStateValidate.isEmailidValid === false
                            ? `form-control ${errors.name && "invalid"}`
                            : ""
                        }
                        value={registerState.emailid}
                        onChange={(e) =>
                          setRegisterState({
                            ...registerState,
                            emailid: e.target.value,
                          })
                        }
                        autocomplete="off"
                      />
                    </div>
                  )}

                  {registerStateValidate.isEmailidValid === false &&
                    registerStateValidate.emailIdValidationMsg ===
                      "emailIdReq" && (
                      <small className="text-danger">
                        {"Email ID is Required"}
                      </small>
                    )}
                  {registerStateValidate.isEmailidValid === false &&
                    registerStateValidate.emailIdValidationMsg ===
                      "emailIdPattern" && (
                      <small className="text-danger">
                        {"Enter Vaild EmailId"}
                      </small>
                    )}

                  {/*Contact no */}
                  {registerState.contactN ? (
                    <div id="enterNameR_school">
                      <div className="input_register_local">
                        +91 {maskPhoneNumber(CNumber)}
                      </div>
                    </div>
                  ) : (
                    <div>
                      <input
                        id="enterNameR"
                        readOnly
                        required
                        placeholder="Mobile number is not registered!!"
                        className={
                          registerStateValidate.isContactValid === false
                            ? `form-control ${errors.name && "invalid"}`
                            : ""
                        }
                        value={registerState.contactN}
                        onChange={(e) =>
                          setRegisterState({
                            ...registerState,
                            contactN: e.target.value,
                          })
                        }
                        autocomplete="off"
                      />
                    </div>
                  )}

                  {/* {registerStateValidate.isContactValid === false &&
                    registerStateValidate.contactValidationMsg ===
                    "contactNReq" && (
                      <small className="text-danger">
                        {"Contact number is Required"}
                      </small>
                    )} */}
                  {/* {registerStateValidate.isContactValid === false &&
                    registerStateValidate.contactValidationMsg ===
                    "contactNPattern" && (
                      <small className="text-danger">
                        {"Enter Vaild Contact Number"}
                      </small>
                    )} */}
                </div>
                <div>
                  <input
                    id="Register_continue_btn"
                    type="submit"
                    className="btn btn-primary my-3"
                    value="Continue"
                    disabled={
                      !registerState?.emailid && !registerState?.contactN
                    }
                    onClick={handleSubmit}
                  />
                </div>
                {/* <div className="total_already_login">
                  <span className="already_login">Already registered?</span>
                  &nbsp;
                  <Link className="Link_register" to="/LoginWithMpin">
                    <span className="login_name">Login</span>
                  </Link>
                </div> */}
              </div>
            </form>
          </div>
        </div>
      )}
      {click && <VerifyMobileEmail registerState={registerState} />}
      {/* </div> */}
    </>
  );
}
